import * as Sentry from "@sentry/browser";
import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";
import api from "../api";
import urls from "../urls";
import type { SiteEnergyWizard } from "../utils/backend-types";

export function useEnergyWizard(
  siteId: number,
  options?: Partial<UseQueryOptions<SiteEnergyWizard>>
) {
  const {
    data: energyWizard,
    isLoading,
    error
  } = useQuery({
    queryKey: ["energyWizard", { siteId }],
    queryFn: () => fetchEnergyWizard(siteId),
    retry: false,
    ...options
  });

  return { energyWizard, isLoading, error };
}

async function fetchEnergyWizard(siteId: number) {
  const energyWizardUrl = urls.api.energyWizard(siteId);
  const response = await api.get<SiteEnergyWizard>(energyWizardUrl);
  const data = response.data;

  if (
    !data ||
    typeof data !== "object" ||
    !data.phases ||
    typeof data.phases !== "object"
  ) {
    Sentry.captureMessage(
      `Unexpected energy wizard response for siteId ${siteId}`,
      { extra: { responseType: typeof data, status: response.status } }
    );
    throw new Error("Unexpected energy wizard response");
  }

  return data;
}
